import RequestApi from "../../modules/requestApi";

const state = {
  // список шаблонов
  templateList: [],
  // шаблон
  template: {}
};

const mutations = {
  // список шаблонов
  SET_TEMPLATE_LIST(state, val) {
    state.templateList = val.sort((a, b) =>
      a.id > b.id ? 1 : b.id > a.id ? -1 : 0
    );
  },
  // записываем шаблон
  SET_TEMPLATE(state, val) {
    state.template = val;
  },
  // перезаписывает объект в списке
  SET_TEMPLATE_ITEM(state, data) {
    // определяем индекс по id
    const index = state.templateList.findIndex(item => item.id === data.id);
    if (index !== -1) {
      // перезаписываем элемент, через удаление, иначе реактивность не срабатывает
      state.templateList.splice(index, 1, {
        ...state.templateList[index],
        ...data
      });
    }
  }
};

const actions = {
  // получаем лист шаблонов статистики
  templateListLoad({ commit }) {
    return new Promise((resolve, reject) => {
      RequestApi.templateList()
        .then(data => {
          commit("SET_TEMPLATE_LIST", data);
          commit("SET_TEMPLATE", data[0]);
          resolve(data);
        })
        .catch(reject);
    });
  },
  // сохранение нового шаблона
  createTemplate({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.createTemplate(params)
        .then(data => {
          commit("SET_TEMPLATE_LIST", [...state.templateList, data]);
          resolve(data);
        })
        .catch(reject);
    });
  },
  // удаление шаблона
  deleteTemplate({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.deleteTemplate(params)
        .then(data => {
          commit(
            "SET_TEMPLATE_LIST",
            state.templateList.filter(item => item.id !== params.id)
          );
          commit("SET_TEMPLATE", state.templateList[0]);
          resolve(data);
        })
        .catch(reject);
    });
  },
  // редактирование темы
  editTemplate({ commit }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.editTemplate(params)
        .then(data => {
          commit("SET_TEMPLATE_ITEM", data);
          resolve(data);
        })
        .catch(reject);
    });
  }
};
const getters = {
  // список шаблонов
  templateList: state => {
    return state.templateList;
  },
  // шаблон
  template: state => {
    return state.template;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
